export var BackgroundStyle = {
  default: 'neutral.lighter',
  avatar1: 'avatar.avatar1',
  avatar2: 'avatar.avatar2',
  avatar3: 'avatar.avatar3',
  avatar4: 'avatar.avatar4',
  avatar5: 'avatar.avatar5',
  avatar6: 'neutral.black'
};
//# sourceMappingURL=Avatar.theme.utils.js.map